import {dispatchUpdateInput} from '@github-ui/search-bar-events'

/**
 * Update the search bar's contents based on the new search.
 */
export function updateSearchBar(search: string): void {
  dispatchUpdateInput(search)
}
